import React, { useState } from 'react'
import { ScrollView, TouchableOpacity, StyleSheet, Image, Text, View, Alert, TextInput, Modal, Platform } from 'react-native'
import { Feather } from '@expo/vector-icons'
import * as ImagePicker from 'expo-image-picker'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { getCurrentUser, signOut } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import { uploadData } from 'aws-amplify/storage'
import theme from '../../../theme'
import awsconfig from '../../aws-exports'
import { useDeviceStore } from '../../redux/zustand/deviceInfoStore'
import { addUser, openDB, updateGlobalVersion, deleteAllTables, deleteAllTablesContent, deleteDB } from '../../db/indexDB'
import { apiUrl } from '../../config/config'
import { manipulateAsync, FlipType, SaveFormat } from 'expo-image-manipulator'
import NetInfo from '@react-native-community/netinfo'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import styles from './EditProfileScreenStyles'
import { avatarPlaceholder, getAvatarPlaceholderLocal } from '../customUtils/Constants'
import { safeImageSource } from '../../utils/imageUtils'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { StatusBar } from 'react-native'
import { SelectList } from 'react-native-dropdown-select-list'
import { getConection } from '../appBar/context/HeaderContext'
import { colorButtonTextEnabled } from '../../../themeConstants'
import { updateAttributesCognito, verifyEmailCode, verifyPhoneNumberCode } from '../../utils/cognitoUtils'
import { request_edit_user_profile } from '../../services/user.services'

// Storage.configure(awsconfig) // TODO: Migrar a Amplify v6

export default function EditProfileScreen({ user_data, avatar, onSave, activeButtonDeleted, onClickDelete }) {
    const [photoURL, setPhotoURL] = useState(avatar)
    console.log('user_data', user_data)
    const [selectedImage, setSelectedImage] = useState(null)
    const fieldsMap = {
        Email: 'email',
        UserID: 'name',
        Nombre: 'last_name',
        Rol: 'role',
        Telefono: 'phone',
    }
    const { isConnected, hasInternet } = getConection()
    const { deviceId, token_notification } = useDeviceStore()
    const [formData, setFormData] = useState(() => {
        const initialFormData = {}
        for (const key in fieldsMap) {
            if (user_data.hasOwnProperty(fieldsMap[key])) {
                initialFormData[key] = user_data[fieldsMap[key]]
            }
        }
        return initialFormData
    })

    const { languageFile } = getLanguage()

    const [languages, setLanguages] = useState(user_data.languages ?? [])

    const defaultLanguage = user_data.lenguage ?? ''

    const [newLanguage, setNewLanguage] = useState(defaultLanguage)
    const [showLanguageAlert, setShowLanguageAlert] = useState(false)
    const [showModalVerification, setShowModalVerification] = useState(false)
    const [showModalVerificationPhone, setShowModalVerificationPhone] = useState(false)
    const [verificationCode, setVerificationCode] = useState('')
    const [verificationCodePhone, setVerificationCodePhone] = useState('')

    const editPhoto = async () => {
        //revisar esto por problemas con los mensajes que tiene IOS para hacer el ipa //
        const cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
        const mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()

        if (cameraPermissionResult.granted === false || mediaLibraryPermissionResult.granted === false) {
            Alert.alert(languageFile.insufficient_permissions, languageFile.permissions_to_access)
            return
        }

        const options = {
            allowsEditing: true,
            aspect: [1, 1],
            quality: 0.3, //1, // la calidad 1 es la mas alta disponible, si  se quiere una calidad baja se puede poner un numero entre 0 y 1, ej, 0.5 y reduce la calidad a la mitad
        }

        Alert.alert(
            languageFile.choose_font,
            languageFile.select_the_image,
            [
                {
                    text: languageFile.camera,
                    onPress: async () => {
                        const pickerResult = await ImagePicker.launchCameraAsync(options)
                        handleImagePickerResult(pickerResult)
                    },
                },
                {
                    text: languageFile.gallery,
                    onPress: async () => {
                        const pickerResult = await ImagePicker.launchImageLibraryAsync(options)
                        handleImagePickerResult(pickerResult)
                    },
                },
            ],
            { cancelable: true },
        )
    }

    const handleImagePickerResult = async (pickerResult) => {
        console.log('🚀 ~ editPhoto ~ pickerResult:', pickerResult)

        if (!pickerResult.cancelled) {
            try {
                const response = await fetch(pickerResult.uri)
                const blob = await response.blob()
                const timestamp = Date.now()
                const filename = `avatars/profile-${user_data._id}-${timestamp}.jpg`
                const thumbnailFilename = `avatars/profile-thumbnail-${user_data._id}-${timestamp}.jpg`
                let sube = await uploadData({
                    key: filename,
                    data: blob,
                    options: {
                        contentType: 'image/jpeg',
                    }
                }).result

                const imageUrl = await getImageStogeUrl(filename)
                console.log('🚀 ~ editPhoto ~ imageUrl:', imageUrl)
                setPhotoURL(imageUrl)
                setSelectedImage({ avatar: filename, thumbnail: thumbnailFilename })

                // Crear una versión miniatura de la imagen con menor calidad y resolución
                const thumbnailOptions = {
                    compress: 0.5, // Comprimir la imagen a la mitad
                    format: 'jpeg', // Formato JPEG
                    base64: false, // No devolver en base64
                    width: 100, // Ancho de la imagen
                    height: 100, // Alto de la imagen
                }
                const thumbnailResult = await manipulateAsync(pickerResult.uri, [{ resize: thumbnailOptions }], {
                    compress: 0.5,
                    format: 'jpeg',
                    base64: false,
                })

                const thumbnailResponse = await fetch(thumbnailResult.uri)
                const thumbnailBlob = await thumbnailResponse.blob()
                const thumbnailSube = await uploadData({
                    key: thumbnailFilename,
                    data: thumbnailBlob,
                    options: {
                        contentType: 'image/jpeg',
                    }
                }).result
                const thumbnailImageUrl = await getImageStogeUrl(thumbnailFilename)
                console.log('🚀 ~ thumbnailImageUrl:', thumbnailImageUrl)
            } catch (error) {
                console.error('Error al subir la imagen:', error)
            }
        }
    }

    const handleFormChange = (key, value) => {
        setFormData({
            ...formData,
            [key]: value,
        })
    }
    const updateProfile = async () => {
        try {
            let data
            const authToken = await getAuthToken()
            if (!authToken) {
                console.warn('[EditProfile] no authToken; skipping remote profile update')
                return
            }
            const user = await getCurrentUser()
            const database = await openDB()
            let originalEmail = user_data['email'].toString().trim()
            let originalPhone = user_data['phone'].toString().trim()
            let editedData = {}

            for (const key in formData) {
                if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
                    editedData[fieldsMap[key]] = formData[key]
                }
            }

            console.log('🚀 ~ updateProfile ~ editedData:', editedData)

            const netInfoState = await NetInfo.fetch()
            if (netInfoState.isConnected) {
                if (selectedImage) {
                    editedData = {
                        ...editedData,
                        avatar_image: selectedImage.avatar,
                        avatar_image_thumbnail: selectedImage.thumbnail,
                    }
                }
                if (newLanguage !== defaultLanguage) {
                    editedData = {
                        ...editedData,
                        language: newLanguage,
                    }
                }

                if (formData['Email'].toString().trim() != originalEmail) {
                    //updateo en cognito el mail
                    let updateCognito = await updateAttributesCognito(editedData, user)
                    if (updateCognito) {
                        setShowModalVerification(true)
                    }
                }

                if (formData['Telefono'].toString().trim() != originalPhone) {
                    //updateo en cognito el mail
                    let { phone: phone_number, ...rest } = editedData
                    // if (!phone_number.startsWith('+549')) {
                    //     phone_number = '+549' + phone_number
                    // }

                    editedData = { phone_number, ...rest }
                    let updateCognito = await updateAttributesCognito(editedData, user)
                    if (updateCognito) {
                        setShowModalVerificationPhone(true)
                    }
                }

                let filterEditedData = Object.keys(editedData)
                    .filter((key) => key !== 'email' && key !== 'phone')
                    .reduce((result, key) => {
                        result[key] = editedData[key]
                        return result
                    }, {})

                // console.log('filterEditedData', filterEditedData)

                const response = await fetch(`${apiUrl}/edit_user_profile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                    },
                    body: JSON.stringify({
                        user_data: filterEditedData,
                    }),
                })

                if (!response.ok) {
                    throw new Error('Fallo al obtener el usuario')
                }

                data = await response.json()
                // console.log('🚀 ~ update users:', data)
            } else {
                console.log('sin conexion')
                data = {
                    status: 0,
                }
            }

            if (data?.status === 1) {
                try {
                    await deleteAllTablesContent()
                    await openDB(true)
                    const user_data = { ...data.single.user_data, delete_active: data.single.delete_active, languages: languages, login: true, cognito_id: session.idToken.payload.sub }
                    await addUser(database, user_data)
                } catch (error) {
                    console.error('Error al agregar usuario:', error)
                }
                let version_update = data.single.user_data.data_version ? data.single.user_data.data_version : 0
                await updateGlobalVersion(database, 'user', version_update)
                console.log('Datos guardados localmente')
                data.single.user_data.avatar = photoURL
                let dataSave = data.single.user_data
                dataSave.languages = languages
                dataSave.delete_active = data.single.delete_active ?? false
                onSave(dataSave)
            }
        } catch (error) {
            console.error('Error al obtener el usuario autenticado:', error)
        }
    }
    const handleDeleteUser = async () => {
        try {
            try {
                let db = await openDB(true)

                const authToken = await getAuthToken()
                if (!authToken) return

                const response = await fetch(`${apiUrl}/oneapp/delete_account`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        device_key: deviceId,
                    },
                })

                console.log('130 🚀 ~ logOut ~ response:', response)
                alert('Tu cuenta fue eliminada correctamente')
                await deleteDB(db)

                // Centralizar logout para disparar limpieza completa (DB, caches, stores)
                try {
                    const { logoutAndReset } = require('../../utils/logout')
                    await logoutAndReset()
                } catch (e) {
                    // Fallback en caso extremo: intentar signOut para que Main.jsx escuche el Hub y limpie
                    try { await signOut() } catch {}
                }
                // No navegamos manualmente; Main.jsx controlará la redirección a Login
                onClickDelete && onClickDelete()
                console.log('delete_account')
            } catch (error) {
                console.log('Error delete_account : ', error)
            }
            console.log('usuario eliminadoo')
        } catch (error) { }
    }
    const onLanguageChange = (val) => {
        setNewLanguage(val)
        setShowLanguageAlert(true)
    }

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen)
    }

    const handleModalVerification = async (verificationCode) => {
    const authToken = await getAuthToken()
    if (!authToken) return
        let verifyCode = await verifyEmailCode(verificationCode)
        let editedData = {}

        for (const key in formData) {
            if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
                editedData[fieldsMap[key]] = formData[key]
            }
        }
        if (verifyCode['success']) {
            setShowModalVerification(false)
            let update_profile = await request_edit_user_profile(authToken, editedData, undefined)
            navigation.navigate('Profile')
        }
    }

    const handleModalCode = () => {
        setShowModalVerification(false)
    }

    const handleModalVerificationPhone = async (verificationCode) => {
    const authToken = await getAuthToken()
    if (!authToken) return
        let verifyCode = await verifyPhoneNumberCode(verificationCode)
        let editedData = {}

        for (const key in formData) {
            if (formData.hasOwnProperty(key) && formData[key] !== user_data[fieldsMap[key]]) {
                editedData[fieldsMap[key]] = formData[key]
            }
        }
        if (verifyCode['success']) {
            setShowModalVerificationPhone(false)
            let update_profile = await request_edit_user_profile(authToken, editedData, undefined)
        }
    }

    return (
        <View style={styles.container}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            {!showLanguageAlert ? (
                <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
                    <View style={styles.containerEditPhoto}>
                        <Image
                            style={styles.avatar}
                            source={safeImageSource(
                                photoURL,
                                Platform.OS === 'web' ? avatarPlaceholder : getAvatarPlaceholderLocal(),
                            )}
                        />

                        <TouchableOpacity onPress={() => editPhoto()} style={styles.containerTextIcon}>
                            <Text style={styles.textButton}>{languageFile.edit_photo}</Text>
                            <View style={styles.iconButton}>
                                <Feather name='edit-2' size={18} color={theme.colors.colorPrimary} />
                            </View>
                        </TouchableOpacity>
                    </View>
                    {isConnected && hasInternet && languages.length > 1 && (
                        <View>
                            <Text style={styles.tagInput}>{languageFile.change_language}</Text>
                            <SelectList
                                placeholder={newLanguage}
                                data={languages}
                                defaultOption={newLanguage}
                                setSelected={(val) => onLanguageChange(val)}
                                save='value'
                                search={false}
                                arrowicon={<Feather name={'chevron-down'} size={22} color={theme.colors.colorPrimary} />}
                                boxStyles={styles.input}
                                dropdownStyles={styles.dropdown}
                                dropdownTextStyles={styles.dropdownOptions}
                                inputStyles={styles.dropdownInput}
                            />
                        </View>
                    )}

                    {Object.keys(formData).map((key) => (
                        <View key={key}>
                            <Text style={styles.tagInput}>{key.charAt(0).toUpperCase() + key.slice(1)}</Text>
                            <TextInput
                                style={styles.inputLocked}
                                onChangeText={(value) => handleFormChange(key, value)}
                                value={formData[key]}
                                placeholder={key.charAt(0).toUpperCase() + key.slice(1)}
                                placeholderTextColor={theme.colors.textSecondary}
                                editable={true}
                            />
                        </View>
                    ))}

                    {showModalVerification && (
                        <Modal
                            animationType='slide'
                            transparent={true}
                            onRequestClose={() => {
                                // Evita cerrar el modal hasta que se verifique el código
                                console.log('El modal de verificación no se puede cerrar hasta que se complete.')
                            }}
                        >
                            <View style={styles.modalOverlay}>
                                <View style={styles.modalContainer}>
                                    <Image style={styles.image} source={require('../../../assets/editEmail.png')} resizeMode='contain' />
                                    <Text style={styles.modalTitle}>Valida tu email</Text>
                                    <Text style={styles.modalSubtitle}>
                                        Estás modificando tu email, recibirás un cósigo en tu correo electrónico para ingresarlo.
                                    </Text>
                                    <Text style={styles.modalSubtitle}>Si aún no recibiste el código, vuelve a verificarlo.</Text>
                                    <Text style={styles.modalTitle}>Código de verificación</Text>
                                    <View style={styles.inputBlock}>
                                        <TextInput
                                            style={styles.input}
                                            placeholder={languageFile.enter_your_new_email}
                                            placeholderTextColor={theme.colors.mediumGray}
                                            onChangeText={(text) => setVerificationCode(text)}
                                            value={verificationCode}
                                            keyboardType='numeric' // Si esperas un código numérico
                                        />
                                    </View>
                                    <View style={styles.buttonContainer}>
                                        <TouchableOpacity
                                            style={[styles.mainButton, { backgroundColor: theme.colors.colorPrimary }]}
                                            onPress={() => handleModalVerification(verificationCode)}
                                        >
                                            <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                                        </TouchableOpacity>
                                    </View>

                                    <View style={styles.buttonContainer}>
                                        <TouchableOpacity style={[styles.borderButton]} onPress={() => handleModalCode()}>
                                            <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                                        </TouchableOpacity>
                                    </View>
                                </View>
                            </View>
                        </Modal>
                    )}

                    {showModalVerificationPhone && (
                        <Modal
                            animationType='slide'
                            transparent={true}
                            onRequestClose={() => {
                                // Evita cerrar el modal hasta que se verifique el código
                                console.log('El modal de verificación no se puede cerrar hasta que se complete.')
                            }}
                        >
                            <View style={styles.modalOverlay}>
                                <View style={styles.modalContainer}>
                                    <Text style={styles.modalTitle}>{languageFile.confirm_your_phone}</Text>

                                    <TextInput
                                        style={styles.input_verification}
                                        placeholder={languageFile.enter_confirmation_code}
                                        placeholderTextColor={theme.colors.mediumGray}
                                        value={verificationCodePhone}
                                        onChangeText={(text) => setVerificationCodePhone(text)}
                                        keyboardType='numeric' // Si esperas un código numérico
                                    />

                                    <TouchableOpacity style={styles.mainButton} onPress={() => handleModalVerificationPhone(verificationCodePhone)}>
                                        <Text style={styles.mainButtonText}>{languageFile.validate_code}</Text>
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </Modal>
                    )}

                    {/* BOTONES ANTERIORES
                <View style={styles.buttonContainer}>
                    <TouchableOpacity onPress={() => onSave()} style={[styles.button, styles.cancelButton]}>
                        <Text style={styles.buttonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => updateProfile()} style={[styles.button, styles.saveButton]}>
                        <Text style={styles.buttonText}>{languageFile.save}</Text>
                    </TouchableOpacity>
                </View>
                */}

                    <TouchableOpacity onPress={() => updateProfile()} style={styles.mainButton}>
                        <Text style={styles.mainButtonText}>{languageFile.confirm}</Text>
                    </TouchableOpacity>
                    <TouchableOpacity onPress={() => onSave()} style={styles.borderRedButton}>
                        <Text style={styles.borderRedButtonText}>{languageFile.cancel}</Text>
                    </TouchableOpacity>
                    {activeButtonDeleted && (
                        <TouchableOpacity onPress={() => handleDeleteUser()} style={styles.deleteBlock}>
                            <Text style={styles.deleteText}>{languageFile.delete_account}</Text>
                        </TouchableOpacity>
                    )}
                </ScrollView>
            ) : (
                <View style={styles.containerModal}>
                    {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                    <Image style={styles.image} source={require('../../../assets/changeLanguage.png')} />
                    <Text style={styles.title}>{languageFile.change_language_title}</Text>
                    <Text style={styles.description}>{languageFile.change_language_message}</Text>
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            onPress={() => {
                                setShowLanguageAlert(false)
                            }}
                            style={styles.mainButton}
                        >
                            <Text style={styles.mainButtonText}>{languageFile.accept}</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={styles.buttonContainer}>
                        <TouchableOpacity
                            onPress={() => {
                                setNewLanguage(defaultLanguage)
                                setShowLanguageAlert(false)
                            }}
                            style={styles.borderButton}
                        >
                            <Text style={styles.borderButtonText}>{languageFile.cancel}</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            )}
        </View>
    )
}
